import UserDetailsPage from "./UserDetailsPage";

export default UserDetailsPage;
